import { render, staticRenderFns } from "./EnderecoCepField.vue?vue&type=template&id=552aded0&scoped=true&"
import script from "./EnderecoCepField.vue?vue&type=script&lang=js&"
export * from "./EnderecoCepField.vue?vue&type=script&lang=js&"
import style0 from "./EnderecoCepField.vue?vue&type=style&index=0&id=552aded0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552aded0",
  null
  
)

export default component.exports